class CartInterstitial extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector('.quick-add-modal__content');
    this.closeBtn = this.querySelector('.quick-add-modal__toggle');
    this.undoBtn = this.querySelector('.cart-interstitial__undo');
    this.continueBtn = this.querySelector('.cart-interstitial__continue');
    this.alertText = this.querySelector('.cart-interstitial__alert-text');
    this.imageContainer = this.querySelector('.cart-interstitial__image');
    this.titleEl = this.querySelector('.cart-interstitial__title');
    this.priceEl = this.querySelector('.cart-interstitial__price');
    this.skuEl = this.querySelector('.cart-interstitial__sku');
    this.quantityEl = this.querySelector('.cart-interstitial__quantity');
    this.variantOptionsEl = this.querySelector('.cart-interstitial__variant-options');
    this.recommendationsContainer = this.querySelector('.cart-interstitial__recommendations');
    this.cartUrl = this.dataset.cartUrl;

    this.closeBtn.addEventListener('click', () => this.hide());
    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });
    this.continueBtn.addEventListener('click', () => this.hide());
    this.undoBtn.addEventListener('click', () => this.handleUndo());
    this.dialog.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.hide();
    });
  }

  show() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    trapFocus(this.dialog, this.dialog);
  }

  hide() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    removeTrapFocus(this.activeElement);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.productId = parsedState.product_id;

    // Update cart icon bubble
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (el && parsedState.sections && parsedState.sections[section.id]) {
        el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
      }
    });

    // Update the header cart count
    this.updateHeaderCartCount();

    // Populate product summary
    this.populateSummary(parsedState);

    // Show the modal
    this.show();

    // Load related product recommendations
    this.loadRecommendations(parsedState.product_id);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  updateHeaderCartCount() {
    fetch(routes.cart_url + '.js')
      .then((r) => r.json())
      .then((cart) => {
        const countEl = document.querySelector('.header__cart-count');
        const cartLink = document.querySelector('.header__action-link--cart');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? '' : 'none';
        } else if (cart.item_count > 0 && cartLink) {
          const span = document.createElement('span');
          span.className = 'header__cart-count';
          span.setAttribute('aria-hidden', 'true');
          span.textContent = cart.item_count;
          cartLink.appendChild(span);
        }
        if (cartLink) {
          cartLink.setAttribute('aria-label', `Shopping Cart: ${cart.item_count} items in cart`);
        }
      })
      .catch(() => {});
  }

  populateSummary(data) {
    // Image
    if (data.image) {
      this.imageContainer.innerHTML = `<img
        src="${this.escapeHtml(data.image)}"
        alt="${this.escapeHtml(data.title || '')}"
        width="200"
        height="200"
        loading="eager"
      >`;
    } else if (data.featured_image && data.featured_image.url) {
      this.imageContainer.innerHTML = `<img
        src="${this.escapeHtml(data.featured_image.url)}"
        alt="${this.escapeHtml(data.featured_image.alt || data.title || '')}"
        width="200"
        height="200"
        loading="eager"
      >`;
    } else {
      this.imageContainer.innerHTML = '';
    }

    // Title
    this.titleEl.textContent = data.product_title || data.title || '';

    // Price
    if (data.final_price != null) {
      this.priceEl.textContent = this.formatMoney(data.final_price);
    } else if (data.price != null) {
      this.priceEl.textContent = this.formatMoney(data.price);
    }

    // SKU
    if (data.sku) {
      this.skuEl.textContent = data.sku;
      this.skuEl.style.display = '';
    } else {
      this.skuEl.style.display = 'none';
    }

    // Quantity
    this.quantityEl.textContent = `Quantity: ${data.quantity || 1}`;

    // Variant options
    if (data.variant_title && data.variant_title !== 'Default Title') {
      this.variantOptionsEl.innerHTML = '';
      const options = data.options_with_values || [];
      if (options.length) {
        options.forEach((opt) => {
          const div = document.createElement('div');
          div.className = 'cart-interstitial__variant-option';
          div.textContent = `${opt.name}: ${opt.value}`;
          this.variantOptionsEl.appendChild(div);
        });
      } else {
        this.variantOptionsEl.textContent = data.variant_title;
      }
      this.variantOptionsEl.style.display = '';
    } else {
      this.variantOptionsEl.style.display = 'none';
    }

    // Alert text
    const productName = data.product_title || data.title || 'Item';
    this.alertText.textContent = `${productName} successfully added to cart`;
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  loadRecommendations(productId) {
    if (!productId) {
      this.recommendationsContainer.innerHTML = '';
      return;
    }

    const url = `/recommendations/products?product_id=${productId}&limit=2&section_id=cart-interstitial-recommendations`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const inner = html.querySelector('.cart-interstitial__recommendations-inner');
        if (inner) {
          this.recommendationsContainer.innerHTML = inner.outerHTML;
        } else {
          this.recommendationsContainer.innerHTML = '';
        }
      })
      .catch(() => {
        this.recommendationsContainer.innerHTML = '';
      });
  }

  handleUndo() {
    if (!this.cartItemKey) return;

    const config = fetchConfig('json');
    config.method = 'POST';
    config.body = JSON.stringify({
      id: this.cartItemKey,
      quantity: 0,
    });

    fetch(routes.cart_change_url, config)
      .then((response) => response.json())
      .then((cart) => {
        this.hide();

        // Update header cart count
        const countEl = document.querySelector('.header__cart-count');
        if (countEl) {
          if (cart.item_count > 0) {
            countEl.textContent = cart.item_count;
            countEl.style.display = '';
          } else {
            countEl.style.display = 'none';
          }
        }

        // Publish cart update event so other components (cart drawer, etc.) stay in sync
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-interstitial',
          cartData: cart,
        });

        // Show snackbar confirmation
        if (window.snackbar) {
          window.snackbar.success('Item removed from cart');
        }
      })
      .catch((err) => {
        console.error('Failed to undo cart addition:', err);
        if (window.snackbar) {
          window.snackbar.error('Failed to remove item from cart');
        }
      });
  }
}

customElements.define('cart-interstitial', CartInterstitial);
